// @file Builders for redirect URLs used by the login page's verification entry-points.
import { buildUrlFromPath, transformUrl } from '@@/bits/location'

export interface PkceParams {
  codeChallenge: string | null
  codeChallengeMethod: string | null
  pkceState: string | null
  originAppClientId: string | null
  originAppRedirectUri: string | null
}

export function appendPkceParams(baseUrl: string, pkce: PkceParams | null): string {
  if (pkce == null) return baseUrl
  return transformUrl(baseUrl, {
    searchParams: {
      code_challenge: pkce.codeChallenge as string,
      code_challenge_method: pkce.codeChallengeMethod as string,
      redirect_uri: pkce.originAppRedirectUri as string,
      client_id: pkce.originAppClientId as string,
      pkce_state: pkce.pkceState as string,
    },
  })
}

export function buildOrgLoginRedirectUrl(pkce: PkceParams | null): string {
  const base = buildUrlFromPath('/auth/org_login_redirect')
  return appendPkceParams(base, pkce)
}

export function buildLibraryLoginRedirectUrl(pkce: PkceParams | null): string {
  const base = buildUrlFromPath('/auth/library_login_redirect')
  return appendPkceParams(base, pkce)
}
